import { FunctionComponent, useEffect, useRef, useState } from "react";
import { NavLink, useHistory } from "react-router-dom";

import { ACTION, MODULE } from "../../../utils/enums";
import {
  GetAnniversary,
  GetBirthdayToday,
} from "../../../service/repos/hrm/hrm_repo";
import {
  getOmniChannelRedirectUrl,
  getRedirectUrl,
  menuUrls,
  new_erp_urls,
  omnichannel_url,
  urls,
} from "../../../utils/urls";
import RequestModal from "./components/RequestModal";
import "./index.css";
import {
  useToast,
  ToastType,
} from "../../../context_providers/toast/toast_ctx";
import { Info, LogOut, User, Zap } from "react-feather";
import { useAuth } from "../../../context_providers/auth/authProvider";
import WishingCard from "./components/WishingCard";
import AnniCard from "./components/AnniCard";
import DockableChatbot from "../ai-chatbot/chatbot";

interface LandingScreenProps {}

const LandingScreen: FunctionComponent<LandingScreenProps> = () => {
  const { user, isAuthorised, logout } = useAuth();
  const [showRequestModal, setShowRequestModal] = useState(false);
  const [showSidePanel, setShowSidePanel] = useState<boolean>(false);
  const [birthData, setBirthData] = useState<[]>([]);
  const [anniData, setAnniData] = useState<[]>([]);
  const [showBirthModal, setShowBirthModal] = useState<boolean>(false);
  const [showAnniModal, setShowAnniModal] = useState<boolean>(false);
  const [accessedModule, setAccessedModule] = useState<any>([]);
  const [declinedModule, setDeclinedModule] = useState<any>([]);
  const [upcomingModule, setUpcomingModule] = useState<any>([]);
  const [showHrmNotify, setShowHrmNotify] = useState<boolean>(false);
  const [showChatbot, setShowChatbot] = useState<boolean>(false);
  const [chatBotHovered, setChatBotHovered] = useState(false);
  const [showAgentComingModal, setShowAgentComingModal] = useState<boolean>(
    () => {
      const lastShown = localStorage.getItem("agentComingModalDate");
      const today = new Date().toDateString();
      return lastShown !== today; // true if not shown today
    },
  );

  const date = new Date();
  const ref = useRef<HTMLDivElement>(null);

  const birthdayToday = async () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();
    const res = await GetBirthdayToday(day, month, year);

    if (res.success) {
      setBirthData(res.data);
      if (res.data.length > 0) {
        handleBirthDay();
      }
    }
  };

  const anniToday = async () => {
    const date = new Date();
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    const res = await GetAnniversary(day, month, year);

    if (res.success) {
      setAnniData(res.data);
      if (res.data.length > 0) {
        handleAnni();
      }
    }
  };

  const handleBirthDay = () => {
    const birthDay = localStorage.getItem("birthDay");
    const today = JSON.stringify(date.getDate());

    if (birthDay) {
      if (birthDay !== today) {
        setTimeout(() => {
          setShowBirthModal(true);
        }, 1000);
        localStorage.setItem("birthDay", today);
      }
    } else {
      setTimeout(() => {
        setShowBirthModal(true);
      }, 1000);
      localStorage.setItem("birthDay", today);
    }
  };
  const handleAnni = () => {
    const anniDay = localStorage.getItem("anniDay");
    const today = JSON.stringify(date.getDate());

    if (anniDay) {
      if (anniDay !== today) {
        setTimeout(() => {
          setShowAnniModal(true);
        }, 1000);
        localStorage.setItem("anniDay", today);
      }
    } else {
      setTimeout(() => {
        setShowAnniModal(true);
      }, 1000);
      localStorage.setItem("anniDay", today);
    }
  };

  useEffect(() => {
    const checkIfClickedOutside = (e: any) => {
      if (showSidePanel && ref?.current && !ref?.current?.contains(e.target)) {
        setShowSidePanel(false);
      }
    };

    document.addEventListener("click", checkIfClickedOutside);

    return () => {
      document.removeEventListener("click", checkIfClickedOutside);
    };
  }, [showSidePanel]);

  useEffect(() => {
    birthdayToday();
    anniToday();
  }, []);

  const getUrl = (module: string) => {
    const links = menuUrls(module);

    // console.log("links for module:", module, links);

    if (links.length > 0) {
      for (let i = 0; i < links.length; i++) {
        const link = links[i];
        const granted = isAuthorised({
          module: link.module,
          action: link.action,
          operator: link.operator,
        });

        if (granted && link.url !== urls.root) {
          return link.url;
        }
      }
    }
  };

  const menus = [
    {
      url: urls.access_guide,
      granted: isAuthorised({
        module: MODULE.access_guide,
        action: [ACTION.READ],
      }),
      icon: "/images/task.svg",
      lable: "Access Guide",
      desc: "Knowledge how to access different modules in ERP",
      dept: "All emloyees",
    },
    {
      url: getUrl(MODULE.access_panel),
      granted: isAuthorised({
        module: MODULE.access_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/access.svg",
      lable: "Access Management",
      desc: "Manage modular access given to the employees in ERP",
      dept: "Tech,Management",
    },

    {
      url: getUrl(MODULE.api_inegration_panel),
      granted: isAuthorised({
        module: MODULE.api_inegration_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/api_img.svg",
      lable: "API Integration",
      desc: "Tech API's",
      dept: "Tech",
    },
    {
      url: getUrl(MODULE.complaint_panel),
      granted: isAuthorised({
        module: MODULE.complaint_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/complaint.svg",
      lable: "Complaints",
      desc: "Create, track and manage the complaints related to our products",
      dept: "All employees",
    },
    {
      url: getUrl(MODULE.request_desk_panel),
      granted: isAuthorised({
        module: MODULE.request_desk_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/task.svg",
      lable: "Request Desk",
      desc: "Raise bugs, new requirements and data-fix service requests on PO / SO / ST",
      dept: "All employees",
    },
    {
      url: urls.hrm_profile,
      granted: isAuthorised({
        module: MODULE.hrm_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/hr.svg",
      lable: "HRM",
      desc: "Apply, track and manage your leaves, upload memories and much more.",
      dept: "All employees, HR",
    },
    {
      url: getUrl(MODULE.device_inventory_panel),
      granted: isAuthorised({
        module: MODULE.device_inventory_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/inventory.svg",
      lable: "Inventory Report",
      desc: "Track inventory, stocked devices, installed devices, etc.",
      dept: "Operations, Management",
    },
    {
      tag: "New",
      url: urls.kazam_academy,
      granted: true,
      icon: "/images/academy.svg",
      lable: "Kazam Academy",
      desc: "Access protocols,videos and understand how Kazam works ",
      dept: "All employees",
    },
    {
      url: new_erp_urls.knowledge_management_home,
      granted: isAuthorised({
        module: MODULE.knowledge_management,
        action: [ACTION.READ],
      }),
      icon: "/images/protocol.svg",
      lable: "Knowledge Management",
      desc: "Manage Knowledge Base Articles",
      dept: "All employees",
    },
    {
      // tag: "Coming soon",

      url: getUrl(MODULE.master_data_panel),
      granted: isAuthorised({
        module: MODULE.master_data_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/master.svg",
      lable: "Masters Data",
      desc: "Master data",
      dept: "Management",
    },
    {
      // Phase 8 — MIS module.
      url: getUrl(MODULE.mis_panel),
      granted: isAuthorised({
        module: MODULE.mis_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/master.svg",
      lable: "MIS",
      desc: "P&L generator — build and view dynamic MIS reports",
      dept: "Finance, Management",
      tag: "New",
    },

    {
      url: getUrl(MODULE.order_panel),
      granted: isAuthorised({
        module: MODULE.order_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/orders.svg",
      lable: "Orders",
      desc: "Create and view orders recieved in the company",
      dept: "Sales, Operation manager, Management",
    },
    {
      // tag: "Coming soon",
      url: getUrl(MODULE.procurement_panel),
      granted: isAuthorised({
        module: MODULE.procurement_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/logistics.svg",
      lable: "Procurement",
      desc: "Procurement",
      dept: "Procurement, Accounts",
    },

    {
      url: new_erp_urls.sop_home,
      granted: isAuthorised({
        module: MODULE.SOP,
        action: [ACTION.READ],
      }),
      icon: "/images/task.svg",
      lable: "SOP",
      desc: "Manage Standard Operating Procedures",
      dept: "All employees",
    },

    {
      tag: "New",
      url: omnichannel_url,
      granted: true,
      icon: "/images/complaint.svg",
      lable: "OmniChannel",
      desc: "Unified customer identity & support console",
      dept: "Support, Operations",
    },

    {
      url: getUrl(MODULE.ops_task_panel),
      granted: isAuthorised({
        module: MODULE.ops_task_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/task1.svg",
      lable: "Tasks Management",
      desc: "Create task, check assigned tasks and manage your operational workflow",
      dept: "Operations,Management",
    },

    {
      url: getUrl(MODULE.content_panel),
      granted: isAuthorised({
        module: MODULE.content_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/icons/content_creator.svg",
      lable: "Website Content panel",
      desc: "Create and manage website content",
      dept: "Content team",
    },
    {
      url: getUrl(MODULE.warehouse_panel),
      granted: isAuthorised({
        module: MODULE.warehouse_panel,
        action: [ACTION.READ],
      }),
      icon: "/images/icons/warehouse.webp",
      lable: "Warehouse Management",
      desc: "Create and manage warehouse stock",
      dept: "Warehouse Team",
    },

    // {
    //   tag: "Coming soon",
    //   url: "/",
    //   granted: true,
    //   icon: "/images/leads.svg",
    //   lable: "Sales Lead",
    //   desc: "Assign and track salesperson target given and achieved",
    //   dept: "Sales, Management",
    // },

    // {
    //   tag: "New",
    //   url: urls.Dashboard,
    //   granted: isAuthorised({
    //     module: MODULE.dashboard,
    //     action: [ACTION.READ],
    //   }),
    //   icon: "/images/data analysis svg.svg",
    //   lable: "Dashboards",
    //   desc: "Department wise Detailed analysis",
    //   dept: "All employees",
    // },
  ];

  const handleModules = () => {
    // console.log("handleModules called");
    const accessModule = menus.filter(
      (el) => el.granted === true && el.tag !== "Coming soon",
    );
    setAccessedModule(accessModule);
    const declinedModule = menus.filter(
      (el) => el.granted === false && el.tag !== "Coming soon",
    );
    setDeclinedModule(declinedModule);
    const upcomingModule = menus.filter(
      (el) => el.tag && el.tag === "Coming soon",
    );
    setUpcomingModule(upcomingModule);
  };

  const handleHrmNotify = () => {
    const hrmUpdate = localStorage.getItem("jobPortal");

    if (hrmUpdate) {
      if (hrmUpdate !== "true") {
        setTimeout(() => {
          setShowHrmNotify(true);
        }, 500);
        localStorage.setItem("jobPortal", "true");
      }
    } else {
      setTimeout(() => {
        setShowHrmNotify(true);
      }, 500);
      localStorage.setItem("jobPortal", "true");
    }
  };

  useEffect(() => {
    handleModules();
    // handleHrmNotify();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleRequestModal = () => {
    setShowRequestModal(!showRequestModal);
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 12) return "Good morning";
    if (hour < 17) return "Good afternoon";
    return "Good evening";
  };

  useEffect(() => {
    if (showAgentComingModal) {
      const today = new Date().toDateString();
      localStorage.setItem("agentComingModalDate", today);
    }
  }, [showAgentComingModal]);

  // Token validation is now handled centrally in AuthProvider
  // No need to check here - if token is expired, AuthProvider will clear session
  // and ProtectedRoute will redirect to login

  return (
    <>
      {showRequestModal && (
        <RequestModal handleRequestModal={handleRequestModal} />
      )}
      {/* {showHrmNotify && <HrmNotify close={() => setShowHrmNotify(false)} />} */}
      <div
        className="relative min-h-screen flex flex-col items-center select-none overflow-y-auto"
        style={{ background: "#1F1F1F" }}
      >
        {/* <marquee className="bg-hrmBlue text-white p-2 text-sm sticky top-0 z-20">
          The leave calendar for the year 2024 has been recently updated and is
          now accessible for your reference. 🎉 {"  "}We are pleased to announce
          that the latest version of the Engineer Task Portal PWA is now live.
          🎉 
        </marquee> */}

        <div
          className="w-full flex justify-between items-center py-3 px-4 sticky top-0 z-30 backdrop-blur"
          style={{
            background: "rgba(31, 31, 31, 0.85)",
            borderBottom: "1px solid rgba(255,255,255,0.06)",
          }}
        >
          <div className="flex items-center gap-2 pl-2">
            <div className="">
              <img src="/images/logo.png" alt="" className="w-8" />
            </div>
            <div className=" lg:text-2xl font-extrabold text-primaryColor">
              ERP Dashboard
            </div>
          </div>

          <div className="mr-2  cursor-pointer landing_dropdown inline-block">
            <div className="w-10 h-10 lg:w-14  lg:h-14 rounded-full ring-2 ring-white ring-opacity-10 hover:ring-teal transition-all overflow-hidden">
              <img
                src={user?.profile_image}
                alt=""
                className="w-full h-full rounded-full object-cover"
              />
            </div>
            <div
              className="nav_sub absolute right-2 border border-white border-opacity-10 shadow-2xl py-6 px-8 rounded-xl"
              style={{ background: "#141414" }}
            >
              <NavLink to={urls.hrm_profile}>
                <div className="flex items-center gap-3">
                  <div className=" font-semibold text-primaryColor">
                    Profile
                  </div>
                  <User className="text-primaryColor" size={18} />
                </div>
              </NavLink>
              <div onClick={logout} className="flex items-center gap-3 mt-3">
                <div className=" font-semibold text-primaryColor">Logout</div>
                <LogOut className="text-primaryColor" size={18} />
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col py-20 w-auto px-4 lg:px-0 overflow-y-auto">
          <div className="mb-10 quote">
            <div className="text-2xl lg:text-3xl font-bold text-primaryColor">
              {getGreeting()}
              {user?.first_name ? `, ${user.first_name}` : ""} 👋
            </div>
            <div className="text-secondaryColor text-sm lg:text-base mt-1">
              Welcome back to your ERP workspace
            </div>
          </div>
          {accessedModule.length > 0 && (
            <div className="">
              <div className="flex items-center gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-teal"></div>
                <div className="text-teal lg:text-xl font-semibold tracking-wide">
                  Access granted
                </div>
                <div className="h-px flex-1 bg-teal bg-opacity-20"></div>
              </div>
              <div className="card_wrapper grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mt-6">
                {accessedModule.map((menu: any, i: number) => {
                  return <MenuTile {...menu} index={i} />;
                })}
              </div>
            </div>
          )}
          {declinedModule.length > 0 && (
            <div className="mt-16">
              <div className="flex items-center gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-hrmRed"></div>
                <div className="text-hrmRed lg:text-xl font-semibold tracking-wide">
                  Modules denied
                </div>
                <div className="h-px flex-1 bg-hrmRed bg-opacity-20"></div>
              </div>

              <div className="card_wrapper grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mt-6">
                {declinedModule.map((menu: any, i: number) => {
                  return <MenuTile {...menu} index={i} />;
                })}
              </div>
            </div>
          )}
          {upcomingModule.length > 0 && (
            <div className="mt-16">
              <div className="flex items-center gap-3">
                <div className="w-1.5 h-1.5 rounded-full bg-hrmPurple"></div>
                <div className="text-hrmPurple lg:text-xl font-semibold tracking-wide">
                  Under development
                </div>
                <div className="h-px flex-1 bg-hrmPurple bg-opacity-20"></div>
              </div>
              <div className="card_wrapper grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8 mt-6">
                {upcomingModule.map((menu: any, i: number) => {
                  return <MenuTile {...menu} index={i} />;
                })}
              </div>
            </div>
          )}
          <div className="flex mt-10 items-center gap-2 justify-center">
            <p className="text-gray-500 text-xs md:text-sm ">Powered by </p>
            <div className=" w-auto ">
              <img src="/assets/logo.png" alt="kazam" className="h-8 md:h-10" />
            </div>
          </div>
        </div>

        <div className="">
          {showBirthModal && (
            <WishingCard
              data={birthData}
              closeBirthdayModal={() => setShowBirthModal(false)}
            />
          )}
          {showAnniModal && (
            <AnniCard
              data={anniData}
              closeAnniModal={() => setShowAnniModal(false)}
            />
          )}
          {/* {showAgentComingModal && (
            <AgentComingCard
              closeAgentComingModal={() => setShowAgentComingModal(false)}
            />
          )} */}
        </div>

        {/* Chatbot Sidebar */}
        {showChatbot && (
          <DockableChatbot onClose={() => setShowChatbot(false)} />
        )}
      </div>

      <button
        onClick={() => setShowChatbot(true)}
        onMouseEnter={() => setChatBotHovered(true)}
        onMouseLeave={() => setChatBotHovered(false)}
        className="group fixed bottom-6 lg:bottom-8 right-4 lg:right-8
        flex items-center gap-2 bg-green-700 text-white font-bold
        shadow-[0_4px_12px_rgba(255,255,255,0.6)] border border-gray-500
        rounded-full px-4 py-3 transition-all duration-300 ease-in-out
        hover:pr-6"
      >
        <Zap height={20} width={20} />

        {chatBotHovered && (
          <span
            className="opacity-0 translate-x-[-10px] scale-95
          group-hover:opacity-100 group-hover:translate-x-0 group-hover:scale-100
          transition-all duration-300 ease-in-out
          whitespace-nowrap overflow-hidden"
          >
            Kazam Agent
          </span>
        )}
      </button>
    </>
  );
};

export default LandingScreen;

interface MenuTileProps {
  index: number;
  desc?: string;
  dept?: string;
  url?: string;
  granted: boolean;
  // onClick: () => void;
  icon: any;
  lable: string;
  tag?: string;
}

const MenuTile: FunctionComponent<MenuTileProps> = ({
  url,
  icon,
  lable,
  desc,
  dept,
  // onClick,
  granted,
  tag,
  index,
}) => {
  const { showToast } = useToast();
  const history = useHistory();
  const [showDesc, setShowDesc] = useState<boolean>(false);

  const onGo = async () => {
    if (!url) return;

    if (url.startsWith("http")) {
      const parsedUrl = new URL(url);
      const redirectPath = parsedUrl.searchParams.get("redirect") || "";
      const redirectUrl = parsedUrl.pathname.startsWith("/auth/callback")
        ? await getOmniChannelRedirectUrl(redirectPath)
        : await getRedirectUrl(redirectPath);
      console.log("redirectUrl : ", redirectUrl);
      window.location.href = redirectUrl;
    } else {
      history.push(url);
    }
  };
  return (
    <div
      className={`group relative card_div py-10 px-6 cursor-pointer homeCard rounded-2xl flex flex-col justify-between items-center ${!granted ? "opacity-60" : ""}`}
      style={{ "--i": index } as any}
      onClick={() => {
        if (granted) onGo();
        else {
          showToast({
            type: ToastType.info,
            text: "Sorry, you don't have access",
          });
        }
      }}
    >
      <div
        className="hidden lg:block absolute top-3 right-3 text-secondaryColor hover:text-teal transition-colors"
        onMouseEnter={() => setShowDesc(true)}
        onMouseLeave={() => setShowDesc(false)}
      >
        <Info size={18} />
      </div>
      {showDesc && (
        <div
          className="absolute right-0 top-8 border border-white border-opacity-10 py-6 px-4 z-20 rounded-xl shadow-2xl"
          style={{ background: "#141414" }}
        >
          <div className="text-white text-base whitespace-nowrap font-bold">
            {lable}
          </div>
          <div className="w-1/2 h-px my-2 bg-secondaryColor bg-opacity-30"></div>
          {desc && (
            <div
              className="text-primaryColor mt-3 text-sm italic whitespace-normal"
              style={{ maxWidth: 220 }}
            >
              {desc}
            </div>
          )}
          {dept && (
            <div className="text-sm mt-6">
              <div className="text-secondaryColor text-xs uppercase tracking-wide">
                Department concerned
              </div>
              <div className="text-white text-sm italic mt-1">{dept}</div>
            </div>
          )}
        </div>
      )}
      <div className="flex flex-col items-center justify-between h-full gap-5">
        <div className="homeCardIcon w-16 h-16 lg:w-20 lg:h-20 rounded-2xl flex items-center justify-center">
          <img src={icon} alt="" className="w-8 lg:w-10" />
        </div>
        <div className="text-base lg:text-lg font-semibold text-primaryColor text-center leading-snug group-hover:text-white transition-colors">
          {lable}
        </div>
      </div>
    </div>
  );
};
